import { declination } from './helpers';

export function counter() {
  function getTimeRemaining(endtime) {
    const t = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((t / 1000) % 60);
    const minutes = Math.floor((t / 1000 / 60) % 60);
    const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    const days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      total: t,
      days,
      hours,
      minutes,
      seconds,
    };
  }

  function initializeClock(id, endtime) {
    const clock = document.querySelector(id);
    const days = clock.querySelector('[data-expire-day]');
    const hours = clock.querySelector('[data-expire-hour]');
    const minutes = clock.querySelector('[data-expire-minute]');
    const seconds = clock.querySelector('[data-expire-second]');

    function updateClock() {
      const t = getTimeRemaining(endtime);

      days.innerHTML = t.days;
      days.setAttribute('data-text', `${t.days === 1 ? 'dzień' : 'dni'}`);
      hours.innerHTML = (`0${t.hours}`).slice(-2);
      declination(t.hours, hours, 'godzin');
      minutes.innerHTML = (`0${t.minutes}`).slice(-2);
      declination(t.minutes, minutes, 'minut');
      seconds.innerHTML = (`0${t.seconds}`).slice(-2);
      declination(t.seconds, seconds, 'sekund');

      if (t.total <= 0) {
        clearInterval(timeinterval);
      }
    }

    updateClock();
    const timeinterval = setInterval(updateClock, 1000);
  }

  if (document.querySelectorAll('.dots__wrapper').length > 0) {
    document.querySelectorAll('.dots__wrapper').forEach((el) => {
      const id = '.dots__wrapper';
      const year = parseInt(el.getAttribute('data-expire-year'), 10);
      const month = parseInt(el.getAttribute('data-expire-month'), 10) - 1;
      const day = parseInt(el.querySelector('[data-expire-day]').getAttribute('data-expire-day'), 10);
      const hour = parseInt(el.querySelector('[data-expire-hour]').getAttribute('data-expire-hour'), 10);
      const minute = parseInt(el.querySelector('[data-expire-minute]').getAttribute('data-expire-minute'), 10);
      const second = parseInt(el.querySelector('[data-expire-second]').getAttribute('data-expire-second'), 10);
      // var deadline = new Date(2021,3,30,23,59,59);
      const deadline = new Date(year, month, day, hour, minute, second);

      if (new Date() < deadline) {
        initializeClock(id, deadline);
      } else {
        el.querySelector('[data-expire-day]').innerText = '00';
        el.querySelector('[data-expire-hour]').innerText = '00';
        el.querySelector('[data-expire-minute]').innerText = '00';
        el.querySelector('[data-expire-second]').innerText = '00';
        document.querySelectorAll('section:not(.section--dark) .btn-main').forEach((btn) => {
          btn.style.display = 'none';
        });
      }
    });
  }
}
